var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload40137Pm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 23.5359L16.0154 19.5513L16.9991 18.5391L19.3 20.84V13H20.7V20.84L23.0009 18.5391L23.9846 19.5513L20 23.5359ZM14.6872 27C14.2157 27 13.8167 26.8367 13.49 26.51C13.1633 26.1833 13 25.7843 13 25.3128V22.782H14.4V25.3128C14.4 25.3846 14.4299 25.4504 14.4898 25.5102C14.5496 25.5701 14.6154 25.6 14.6872 25.6H25.3128C25.3846 25.6 25.4504 25.5701 25.5102 25.5102C25.5701 25.4504 25.6 25.3846 25.6 25.3128V22.782H27V25.3128C27 25.7843 26.8367 26.1833 26.51 26.51C26.1833 26.8367 25.7843 27 25.3128 27H14.6872Z",
    fill: "#3B84E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload40137Pm);
export default __webpack_public_path__ + "static/media/download 4.01.37 PM.bab4486fea61e4b6696ef6eb2116fb4d.svg";
export { ForwardRef as ReactComponent };